import HeroSection from '@/components/HeroSection'
import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'

export default function BusinessPage() {
  const currentProjects = [
    {
      id: '1',
      name: 'Veteran General Contracting',
      description: 'By Mr. Mohammed Ghassan A Al Rifai',
      logo: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    },
    {
      id: '2',
      name: 'Zenith Digital Egency',
      description: 'By Mr. Mohammed Ghassan A Al Rifai',
      logo: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    },
  ]

  const comingSoonProjects = [
    {
      id: '1',
      name: 'Treasure Deal Invest',
      description: 'By Mr. Mohammed Ghassan A Al Rifai',
    },
    {
      id: '2',
      name: 'Treasure Deal Group',
      description: 'By Mr. Mohammed Ghassan A Al Rifai',
    },
  ]

  const blogPosts = [
    {
      id: '1',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '2',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
    {
      id: '3',
      title: 'Fly High With Our Exclusive Travel Tips',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=300&fit=crop',
      date: '24/08/2024',
      category: 'Travel',
      likes: 23,
      comments: 5,
    },
  ]

  return (
    <>
      {/* Hero */}
      <HeroSection
        variant="blue"
        title="BUSINESS"
        imageUrl="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=400&fit=crop"
      />

      {/* Intro Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <h2 className="text-4xl font-bold text-foreground mb-4 text-balance">
            FROM VISIONARY BEGINNINGS TO BUSINESS INNOVATION
          </h2>
          <p className="text-muted-foreground text-lg mb-12 text-balance">
            Learn About The Key Qualities That Make A Venture Partner Successful. Effective Partnerships Are Built On Traits That Lead To Success And Good Collaboration.
          </p>

          <div className="bg-card border border-border rounded-lg p-8 mb-8">
            <div className="font-bold text-foreground mb-2">
              MEET US AT WORLDEF DUBAI BLOCK C17
            </div>
            <div className="text-muted-foreground mb-4">
              ⏰ 4 Days Left & 23h - 25m - 12s
            </div>
            <div className="mb-6">
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=100&fit=crop" alt="WORLDEF" className="h-20 object-contain mx-auto" />
            </div>
            <button className="px-8 py-2 border border-foreground text-foreground rounded hover:bg-foreground hover:text-background transition-colors">
              SOMETHING BIG IS COMING SOON...
            </button>
          </div>
        </div>
      </section>

      {/* Coming Soon Projects */}
      <section className="py-20 bg-secondary">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-foreground mb-4 text-center">
            Coming Soon Projects
          </h2>
          <p className="text-center text-muted-foreground mb-12 max-w-3xl mx-auto text-balance">
            At Mohammad Ghassan Alfifai, The Focus Is On New And Exciting Projects That Will Be Revealed Soon, Aiming To Create Solutions For The Future.
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            {comingSoonProjects.map((project) => (
              <div key={project.id} className="bg-background border border-border rounded-lg p-8 text-center hover:border-accent transition-colors">
                <div className="mb-4">
                  <div className="w-40 h-40 mx-auto bg-card rounded-lg flex items-center justify-center border border-border">
                    <span className="text-muted-foreground text-sm">Logo</span>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-foreground mb-2">{project.name}</h3>
                <p className="text-muted-foreground text-sm">{project.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Current Projects */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-foreground mb-12 text-center">
            Current Projects
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {currentProjects.map((project) => (
              <div key={project.id} className="border border-border rounded-lg overflow-hidden hover:border-accent transition-colors">
                <div className="h-48 bg-card overflow-hidden">
                  <img src={project.logo} alt={project.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-foreground mb-2">{project.name}</h3>
                  <p className="text-muted-foreground text-sm">{project.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-secondary">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-foreground mb-2 text-center">
            From His Blog
          </h2>
          <p className="text-center text-muted-foreground mb-12 text-balance">
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects. Stay Updated With Content Relevant To You.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <BlogCard key={post.id} {...post} />
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <NewsletterSection />
    </>
  )
}
